import React, { useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

function AddClientForm({ userId, onClientAdded, onCancel }) {
  const [formData, setFormData] = useState({
    client_name: '',
    brand_color_primary: '#EC6433',
    assigned_com_id: userId,  // Default to current user
    instagram_url: '',
    facebook_url: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [coms, setComs] = useState([]);
  const [userRole, setUserRole] = useState(null);

  // Fetch COMs if admin
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const authRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/check`, {
          withCredentials: true
        });
        setUserRole(authRes.data.user?.role);

        if (authRes.data.user?.role === 'admin' || authRes.data.user?.role === 'superadmin') {
          const comsRes = await axios.get(`${process.env.REACT_APP_API_URL}/api/users`, {
            withCredentials: true
          });
          setComs(comsRes.data.users || []);
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitting(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/clients`, {
        ...formData,
        assigned_com_id: formData.assigned_com_id,
        reporting_schedule: 'quarterly'
      }, {
        withCredentials: true
      });

      if (response.data.success) {
        onClientAdded(response.data.client);

        setFormData({
          client_name: '',
          brand_color_primary: '#EC6433',
          assigned_com_id: userId
        });
      }
    } catch (err) {
      toast.error('Failed to add client');
      console.error('Error adding client:', err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="add-client-form">
      <h3>➕ Add New Client</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <input
            type="text"
            name="client_name"
            placeholder="Client Name *"
            value={formData.client_name}
            onChange={handleChange}
            required
            disabled={submitting}
          />
        </div>

        <div className="form-row" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
          <label style={{ minWidth: '140px', margin: 0 }}>Brand Color (Primary):</label>
          <input
            type="color"
            name="brand_color_primary"
            value={formData.brand_color_primary}
            onChange={handleChange}
            disabled={submitting}
            style={{ width: '60px', height: '40px', cursor: 'pointer', border: '1px solid #ddd', borderRadius: '4px' }}
          />
          <input
            type="text"
            name="brand_color_primary"
            value={formData.brand_color_primary}
            onChange={handleChange}
            placeholder="#EC6433"
            disabled={submitting}
            style={{ flex: 1 }}
          />
        </div>

        {(userRole === 'admin' || userRole === 'superadmin') && coms.length > 0 && (
          <div className="form-row">
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
              Assign to User *
            </label>
            <select
              name="assigned_com_id"
              value={formData.assigned_com_id}
              onChange={handleChange}
              required
              disabled={submitting}
              style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' }}
            >
              {coms.map(com => (
                <option key={com.id} value={com.id}>
                  {com.name} ({com.email})
                </option>
              ))}
            </select>
          </div>
        )}

        <div className="form-row">
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>Instagram URL <span style={{ color: '#999', fontWeight: '400' }}>(optional)</span></label>
          <input
            type="url"
            name="instagram_url"
            placeholder="https://instagram.com/yourclient"
            value={formData.instagram_url}
            onChange={handleChange}
            disabled={submitting}
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd', boxSizing: 'border-box' }}
          />
        </div>

        <div className="form-row">
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>Facebook Page URL <span style={{ color: '#999', fontWeight: '400' }}>(optional)</span></label>
          <input
            type="url"
            name="facebook_url"
            placeholder="https://facebook.com/yourclientpage"
            value={formData.facebook_url}
            onChange={handleChange}
            disabled={submitting}
            style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd', boxSizing: 'border-box' }}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? '⏳ Adding...' : '✅ Add Client'}
          </button>
          <button type="button" onClick={onCancel} className="btn-secondary">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddClientForm;